



import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import LoadSpinner from "../../component/Modals/LoadSpinner";
import { Modal } from "flowbite-react";
import UrgentJobSeekerButton from "./UrgentJobSeekerButton";
import { io } from "socket.io-client";
import { useSelector, useDispatch } from "react-redux";
const UrgentJobSeekerAccept = () => {
    const dispatch = useDispatch();
    const { currentUser, token } = useSelector((state) => state.user);
    const loggedInUser = useSelector((state) => state.user);
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [travelTime, setTravelTime] = useState("");
  const userId = localStorage.getItem("userId");
    const [profileInfo, setProfileInfo] = useState({
      jobSeekerId: loggedInUser?.currentUser?._id,
    });




    useEffect(() => {
      setProfileInfo({
        jobSeekerId: loggedInUser?.currentUser?._id,})
    })

  useEffect(() => {

    const socket = io(process.env.REACT_APP_API_URL, { query: { userId } });

    socket.on("connect", () => {
      console.log("Socket.IO connected for job seeker:", userId);
    });

    socket.on("newUrgentRequest", (request) => {
      console.log("New urgent request received:", request);
      setRequests((prev) =>
        [...prev, { ...request, selectedJobSeeker: null, paymentStatus: "pending" }].filter(
          (r, i, self) => i === self.findIndex((t) => t._id === r._id)
        )
      );
      toast.info(`New urgent job available: ${request.position}`);
    });

    socket.on("selectionUpdate", (data) => {
      console.log("Selection update received:", data);
      setRequests((prev) =>
        prev.map((r) =>
          r._id === data.requestId
            ? {
                ...r,
                selectedJobSeeker: data.selectedJobSeeker,
                selectedJobSeekerDetails: data.selectedJobSeekerDetails || null,
                paymentStatus: data.transactionRef ? "paid" : "pending",
              }
            : r
        )
      );
      if (data.selectedJobSeeker === userId) {
        toast.success("You have been selected for the job!");
      } else {
        toast.info("Another candidate has been selected for this job.");
      }
    });

    socket.on("paymentUpdate", (data) => {
      console.log("Payment update received:", data);
      if (data.status === "assigned" && data.jobSeekerDetails._id === userId) {
        toast.success(
          `You have been paid N${requests.find((r) => r._id === data.requestId)?.amount} for the job!`
        );
        setRequests((prev) =>
          prev.map((r) =>
            r._id === data.requestId ? { ...r, paymentStatus: "paid", status: "assigned" } : r
          )
        );
      }
    });

    socket.on("adminAllocation", (data) => {
      console.log("Admin allocation received:", data);
      if (data.selectedJobSeeker === userId) {
        toast.success(`Admin assigned you to job: ${data.requestId}`);
        setRequests((prev) =>
          prev.map((req) =>
            req._id === data.requestId
              ? {
                  ...req,
                  status: "assigned",
                  selectedJobSeeker: data.selectedJobSeeker,
                  selectedJobSeekerDetails: data.selectedJobSeekerDetails,
                  allocatedBy: data.allocatedBy,
                }
              : req
          )
        );
      }
    });

    const fetchRequests = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          // `${process.env.REACT_APP_API_URL}urgent/requests/available/${userId}`,
          `${process.env.REACT_APP_API_URL}urgent/all-urgent-requests`,
          { headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` } }
        );
        console.log("Fetched urgent requests:", response.data.requests);
        setRequests(
          response.data.requests.map((r) => ({
            ...r,
            selectedJobSeeker: r.selectedJobSeeker || null,
            selectedJobSeekerDetails: r.selectedJobSeeker
              ? {
                  firstName: r.selectedJobSeeker.firstName || "N/A",
                  lastName: r.selectedJobSeeker.lastName || "N/A",
                  email: r.selectedJobSeeker.email || "N/A",
                  phoneNumber: r.selectedJobSeeker.phoneNumber || "N/A",
                }
              : null,
            paymentStatus: r.selectedJobSeeker && r.transactionRef ? "paid" : "pending",
            userIdDetails: r.userId
              ? {
                  email: r.userId.email || "N/A",
                  phoneNumber: r.userId.phoneNumber || "N/A",
                  companyName: r.userId.companyName || "N/A",
                }
              : { email: "N/A", phoneNumber: "N/A", companyName: "N/A" },
            acceptedBy: r.acceptedBy || [],
          }))
        );
      } catch (error) {
        console.error("Error fetching requests:", error.response?.data || error.message);
        toast.error(error.response?.data?.message || "Error fetching requests");
      } finally {
        setLoading(false);
      }
    };
    fetchRequests();

    return () => {
      socket.off("connect");
      socket.off("newUrgentRequest");
      socket.off("selectionUpdate");
      socket.off("paymentUpdate");
      socket.off("adminAllocation");
      socket.disconnect();
    };
  }, [userId]);

  const handleAccept = async (requestId) => {
    if (!travelTime) {
      toast.error("Please enter estimated travel time");
      return;
    }
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}urgent/accept-urgent-request`,
        { requestId, jobSeekerId: userId, travelTime },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` } }
      );
      toast.success("Request accepted");
      setRequests((prev) =>
        prev.map((r) =>
          r._id === requestId
            ? {
                ...r,
                acceptedBy: [
                  ...r.acceptedBy,
                  {
                    jobSeekerId: userId,
                    travelTime,
                    firstName: "Current User", // Placeholder, updated via socket
                    lastName: "",
                    email: "",
                    phoneNumber: "",
                  },
                ],
              }
            : r
        )
      );
      setTravelTime("");
    } catch (error) {
      console.error("Error accepting request:", error.response?.data || error.message);
      toast.error(error.response?.data?.message || "Error accepting request");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4">Urgent Job Requests</h2>
      <UrgentJobSeekerButton />
      {loading && <LoadSpinner />}
      {requests.length === 0 && !loading && (
        <p className="text-gray-600 mt-4">No urgent job requests available at this time.</p>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {requests.map((request) => (
          <div key={request._id} className="p-4 bg-white rounded-lg shadow-md relative">
            {request.selectedJobSeeker && (
              <span className="absolute top-2 right-2 bg-yellow-600 text-white text-xs px-2 py-1 rounded-full">
                Candidate Selected
              </span>
            )}
            {request.paymentStatus === "paid" && request.selectedJobSeeker === userId && (
              <span className="absolute top-2 right-2 bg-green-600 text-white text-xs px-2 py-1 rounded-full">
                Paid
              </span>
            )}
            {request.selectedJobSeeker && request.selectedJobSeekerDetails && (
              <div className="mt-2 text-gray-700">
                <p>
                  <strong>Selected Candidate:</strong> {request.selectedJobSeekerDetails.firstName}{" "}
                  {request.selectedJobSeekerDetails.lastName}
                </p>
                <p>
                  <strong>Email:</strong> {request.selectedJobSeekerDetails.email}{" "}
                  {request.selectedJobSeeker === userId ? "(YOU)" : ""}
                </p>
                <p><strong>Phone:</strong> {request.selectedJobSeekerDetails.phoneNumber}</p>
              </div>
            )}
            {request.userIdDetails && (
              <div className="mt-2 text-gray-700">
                <p><strong>Employer Company:</strong> {request.userIdDetails.companyName}</p>
                <p><strong>Employer Email:</strong> {request.userIdDetails.email}</p>
                <p><strong>Employer Phone:</strong> {request.userIdDetails.phoneNumber}</p>
              </div>
            )}
            {request.selectedJobSeeker === userId  && (
              <p className="mt-2 text-green-600 font-semibold">
                You are selected and paid for this job!
              </p>
            )}
            <h3 className="text-lg font-medium text-gray-800">{request.position}</h3>
            <p className="text-gray-600">
              Duration: {request.durationValue} {request.durationType}
            </p>
            <p className="text-gray-600">Amount: N{request.amount}</p>
            <button
              onClick={() => setSelectedRequest(request)}
              className="mt-2 bg-gray-500 text-white py-1 px-3 rounded-md hover:bg-gray-600"
            >
              View Details
            </button>
            {!request.acceptedBy.some((a) => a.jobSeekerId === userId) && !request.selectedJobSeeker && (
              <div className="mt-2">
                <input
                  type="text"
                  placeholder="Estimated travel time (e.g., 2 hours)"
                  value={travelTime}
                  onChange={(e) => setTravelTime(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md mb-2"
                />
                <button
                  onClick={() => handleAccept(request._id)}
                  className="mt-2 ml-2 bg-green-600 text-white py-1 px-3 rounded-md hover:bg-green-700"
                  disabled={loading}
                >
                  {loading ? <LoadSpinner /> : "Accept"}
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
      {selectedRequest && (
        <Modal show={!!selectedRequest} onClose={() => setSelectedRequest(null)} title="Request Details">
          <Modal.Body>
            <div className="p-4">
              <p><strong>Position:</strong> {selectedRequest.position}</p>
              <p>
                <strong>Duration:</strong> {selectedRequest.durationValue} {selectedRequest.durationType}
              </p>
              <p><strong>Amount:</strong> N{selectedRequest.amount}</p>
              {selectedRequest.userIdDetails && (
                <div>
                  <p><strong>Employer Company:</strong> {selectedRequest.userIdDetails.companyName}</p>
                  <p><strong>Employer Email:</strong> {selectedRequest.userIdDetails.email}</p>
                  <p><strong>Employer Phone:</strong> {selectedRequest.userIdDetails.phoneNumber}</p>
                </div>
              )}
              {selectedRequest.selectedJobSeeker && selectedRequest.selectedJobSeekerDetails && (
                <div className="mt-2">
                  <p>
                    <strong>Selected Candidate:</strong> {selectedRequest.selectedJobSeekerDetails.firstName}{" "}
                    {selectedRequest.selectedJobSeekerDetails.lastName}
                  </p>
                  <p>
                    <strong>Email:</strong> {selectedRequest.selectedJobSeekerDetails.email}{" "}
                    {selectedRequest.selectedJobSeeker === userId ? "(YOU)" : ""}
                  </p>
                  <p><strong>Phone:</strong> {selectedRequest.selectedJobSeekerDetails.phoneNumber}</p>
                </div>
              )}
              <p><strong>Benefits:</strong> {selectedRequest.benefits?.join(", ") || "None"}</p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={() => setSelectedRequest(null)}
              className="bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-700"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default UrgentJobSeekerAccept;





// import { useState, useEffect } from "react";
// import axios from "axios";
// import { toast } from "react-toastify";
// import LoadSpinner from "../../component/Modals/LoadSpinner";
// import { Modal } from "flowbite-react";
// import UrgentJobSeekerButton from "./UrgentJobSeekerButton";
// import { useSocket } from "../../hooks/useSocket";
// import { useSelector } from "react-redux";

// const UrgentJobSeekerAccept = () => {
//   const [requests, setRequests] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedRequest, setSelectedRequest] = useState(null);
//   const [travelTime, setTravelTime] = useState("");
//   const [messages, setMessages] = useState({});
//   const [chatInput, setChatInput] = useState("");
//   const [peerConnection, setPeerConnection] = useState(null);
//   const userId = localStorage.getItem("userId");
//   const token = localStorage.getItem("token");
//   const { socket, connectSocket } = useSocket();
//   const currentUser = useSelector((state) => state.user.currentUser);

//   useEffect(() => {
//     if (userId && token) {
//       connectSocket(userId);
//     } else {
//       toast.error("Please log in to continue");
//       return;
//     }

//     if (socket) {
//       socket.on("newUrgentRequest", (request) => {
//         setRequests((prev) => [
//           ...prev.filter((r) => r._id !== request._id),
//           { ...request, selectedJobSeeker: null, paymentStatus: "pending", status: "pending" },
//         ]);
//         toast.info(`New urgent job: ${request.position}`);
//       });

//       socket.on("selectionUpdate", (data) => {
//         setRequests((prev) =>
//           prev.map((r) =>
//             r._id === data.requestId
//               ? { ...r, selectedJobSeeker: data.selectedJobSeeker, selectedJobSeekerDetails: data.selectedJobSeekerDetails, paymentStatus: "pending" }
//               : r
//           )
//         );
//         if (data.selectedJobSeeker === userId) {
//           toast.success("You were selected!");
//         } else {
//           toast.info("Another candidate selected.");
//         }
//       });

//       socket.on("paymentUpdate", (data) => {
//         if (data.jobSeekerDetails?._id === userId) {
//           toast.success(`Paid N${data.jobDetails.amount} for job`);
//           setRequests((prev) =>
//             prev.map((r) =>
//               r._id === data.requestId ? { ...r, status: "assigned", paymentStatus: "paid" } : r
//             )
//           );
//           fetchChatHistory(data.requestId);
//         }
//       });

//       socket.on("adminAllocation", (data) => {
//         if (data.selectedJobSeeker === userId) {
//           toast.success(`Assigned to job ${data.requestId}`);
//           setRequests((prev) =>
//             prev.map((r) =>
//               r._id === data.requestId
//                 ? { ...r, status: "assigned", selectedJobSeeker: data.selectedJobSeeker, selectedJobSeekerDetails: data.selectedJobSeekerDetails }
//                 : r
//             )
//           );
//           fetchChatHistory(data.requestId);
//         }
//       });

//       socket.on("requestCancelled", (data) => {
//         setRequests((prev) => prev.filter((r) => r._id !== data.requestId));
//         toast.info(data.message);
//       });

//       socket.on("acceptanceCancelled", (data) => {
//         setRequests((prev) =>
//           prev.map((r) =>
//             r._id === data.requestId
//               ? { ...r, acceptedBy: r.acceptedBy.filter((a) => a.jobSeekerId !== data.jobSeekerId) }
//               : r
//           )
//         );
//         toast.info(data.message);
//       });

//       socket.on("newMessage", (msg) => {
//         setMessages((prev) => ({
//           ...prev,
//           [msg.requestId]: [...(prev[msg.requestId] || []), msg],
//         }));
//         toast.info(`New message in request ${msg.requestId}`);
//       });

//       socket.on("callOffer", async (data) => {
//         const pc = new RTCPeerConnection({ iceServers: [{ urls: "stun:stun.l.google.com:19302" }] });
//         setPeerConnection(pc);
//         await pc.setRemoteDescription(new RTCSessionDescription(data.offer));
//         const answer = await pc.createAnswer();
//         await pc.setLocalDescription(answer);
//         socket.emit("callAnswer", { requestId: data.requestId, answer, calleeId: userId });

//         pc.ontrack = (event) => {
//           const remoteVideo = document.getElementById(`remoteVideo-${data.requestId}`);
//           if (remoteVideo) remoteVideo.srcObject = event.streams[0];
//         };

//         pc.onicecandidate = (event) => {
//           if (event.candidate) {
//             socket.emit("iceCandidate", { requestId: data.requestId, candidate: event.candidate, senderId: userId });
//           }
//         };

//         const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
//         stream.getTracks().forEach((track) => pc.addTrack(track, stream));
//         const localVideo = document.getElementById(`localVideo-${data.requestId}`);
//         if (localVideo) localVideo.srcObject = stream;

//         toast.info(`Incoming call for request ${data.requestId}`);
//       });

//       socket.on("callAnswer", async (data) => {
//         if (peerConnection) {
//           await peerConnection.setRemoteDescription(new RTCSessionDescription(data.answer));
//         }
//       });

//       socket.on("iceCandidate", async (data) => {
//         if (peerConnection) {
//           await peerConnection.addIceCandidate(new RTCIceCandidate(data.candidate));
//         }
//       });

//       socket.on("error", (data) => {
//         toast.error(data.message);
//       });
//     }

//     const fetchRequests = async () => {
//       setLoading(true);
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_URL}urgent/requests/available/${userId}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         setRequests(
//           response.data.requests.map((r) => ({
//             ...r,
//             userIdDetails: r.userId ? r.userId : { companyName: "N/A", email: "N/A", phoneNumber: "N/A" },
//             selectedJobSeekerDetails: r.selectedJobSeeker || null,
//             paymentStatus: r.transactionRef ? "paid" : "pending",
//             acceptedBy: r.acceptedBy || [],
//           }))
//         );
//       } catch (error) {
//         toast.error(error.response?.data?.message || "Failed to fetch requests");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchRequests();

//     return () => {
//       if (socket) {
//         socket.off("newUrgentRequest");
//         socket.off("selectionUpdate");
//         socket.off("paymentUpdate");
//         socket.off("adminAllocation");
//         socket.off("requestCancelled");
//         socket.off("acceptanceCancelled");
//         socket.off("newMessage");
//         socket.off("callOffer");
//         socket.off("callAnswer");
//         socket.off("iceCandidate");
//         socket.off("error");
//       }
//     };
//   }, [userId, token, socket, connectSocket]);

//   const fetchChatHistory = async (requestId) => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_URL}urgent/chat-history/${requestId}/${userId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setMessages((prev) => ({ ...prev, [requestId]: response.data.messages }));
//     } catch (error) {
//       toast.error("Failed to fetch chat history");
//     }
//   };

//   const handleAccept = async (requestId) => {
//     if (!travelTime) {
//       toast.error("Please enter travel time");
//       return;
//     }
//     try {
//       setLoading(true);
//       await axios.post(
//         `${process.env.REACT_APP_API_URL}urgent/accept-urgent-request`,
//         { requestId, jobSeekerId: userId, travelTime },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       toast.success("Request accepted");
//       setRequests((prev) =>
//         prev.map((r) =>
//           r._id === requestId
//             ? {
//                 ...r,
//                 acceptedBy: [
//                   ...r.acceptedBy,
//                   {
//                     jobSeekerId: userId,
//                     travelTime,
//                     firstName: currentUser?.firstName || "You",
//                     lastName: currentUser?.lastName || "",
//                   },
//                 ],
//               }
//             : r
//         )
//       );
//       setTravelTime("");
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Failed to accept request");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCancelAcceptance = async (requestId) => {
//     try {
//       setLoading(true);
//       await axios.post(
//         `${process.env.REACT_APP_API_URL}urgent/cancel-acceptance`,
//         { requestId, jobSeekerId: userId },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       toast.success("Acceptance cancelled");
//       setRequests((prev) =>
//         prev.map((r) =>
//           r._id === requestId
//             ? { ...r, acceptedBy: r.acceptedBy.filter((a) => a.jobSeekerId !== userId) }
//             : r
//         )
//       );
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Failed to cancel acceptance");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const sendMessage = (requestId) => {
//     if (!chatInput) return;
//     socket.emit("sendMessage", { requestId, senderId: userId, message: chatInput });
//     setMessages((prev) => ({
//       ...prev,
//       [requestId]: [...(prev[requestId] || []), { senderId: userId, message: chatInput, timestamp: new Date() }],
//     }));
//     setChatInput("");
//   };

//   const startCall = async (requestId) => {
//     try {
//       const pc = new RTCPeerConnection({ iceServers: [{ urls: "stun:stun.l.google.com:19302" }] });
//       setPeerConnection(pc);

//       const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
//       const localVideo = document.getElementById(`localVideo-${requestId}`);
//       if (localVideo) localVideo.srcObject = stream;
//       stream.getTracks().forEach((track) => pc.addTrack(track, stream));

//       pc.onicecandidate = (event) => {
//         if (event.candidate) {
//           socket.emit("iceCandidate", { requestId, candidate: event.candidate, senderId: userId });
//         }
//       };

//       pc.ontrack = (event) => {
//         const remoteVideo = document.getElementById(`remoteVideo-${requestId}`);
//         if (remoteVideo) remoteVideo.srcObject = event.streams[0];
//       };

//       const offer = await pc.createOffer();
//       await pc.setLocalDescription(offer);
//       socket.emit("callOffer", { requestId, offer, callerId: userId });
//     } catch (error) {
//       toast.error("Failed to start call");
//       console.error(error);
//     }
//   };

//   const makePhoneCall = (phoneNumber) => {
//     const link = document.createElement("a");
//     link.href = `tel:${phoneNumber}`;
//     link.style.display = "none";
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   return (
//     <div className="p-6 bg-gray-100 min-h-screen">
//       <h2 className="text-2xl font-bold text-gray-800 mb-6">Urgent Job Requests</h2>
//       <UrgentJobSeekerButton />
//       {loading && <LoadSpinner />}
//       {requests.length === 0 && !loading && (
//         <p className="text-gray-600 text-center mt-4">No urgent job requests available.</p>
//       )}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//         {requests.map((request) => (
//           <div
//             key={request._id}
//             className="bg-white rounded-lg shadow-md p-6 relative hover:shadow-lg transition-shadow"
//           >
//             {request.selectedJobSeeker && (
//               <span className="absolute top-2 right-2 bg-yellow-500 text-white text-xs px-2 py-1 rounded-full">
//                 Candidate Selected
//               </span>
//             )}
//             {request.paymentStatus === "paid" && request.selectedJobSeeker === userId && (
//               <span className="absolute top-2 right-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full">
//                 Paid
//               </span>
//             )}
//             <h3 className="text-lg font-semibold text-gray-800">{request.position}</h3>
//             <p className="text-gray-600">Duration: {request.durationValue} {request.durationType}</p>
//             <p className="text-gray-600">Amount: N{request.amount}</p>
//             {request.userIdDetails && (
//               <div className="mt-2 text-gray-600">
//                 <p><span className="font-medium">Employer:</span> {request.userIdDetails.companyName}</p>
//                 <p><span className="font-medium">Email:</span> {request.userIdDetails.email}</p>
//                 <p><span className="font-medium">Phone:</span> {request.userIdDetails.phoneNumber}</p>
//               </div>
//             )}
//             {request.selectedJobSeekerDetails && request.selectedJobSeeker === userId && request.paymentStatus === "paid" && (
//               <p className="text-green-600 font-semibold mt-2">You are selected and paid!</p>
//             )}
//             <div className="mt-4 flex space-x-2">
//               <button
//                 onClick={() => setSelectedRequest(request)}
//                 className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition"
//               >
//                 View Details
//               </button>
//               {!request.acceptedBy.some((a) => a.jobSeekerId === userId) && !request.selectedJobSeeker && request.status === "pending" && (
//                 <div className="flex-1">
//                   <input
//                     type="text"
//                     placeholder="Travel time (e.g., 2 hours)"
//                     value={travelTime}
//                     onChange={(e) => setTravelTime(e.target.value)}
//                     className="w-full px-3 py-2 border border-gray-300 rounded-md mb-2 focus:ring-2 focus:ring-blue-500"
//                   />
//                   <button
//                     onClick={() => handleAccept(request._id)}
//                     className="bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 transition"
//                     disabled={loading}
//                   >
//                     {loading ? <LoadSpinner /> : "Accept"}
//                   </button>
//                 </div>
//               )}
//               {request.acceptedBy.some((a) => a.jobSeekerId === userId) && request.status === "pending" && (
//                 <button
//                   onClick={() => handleCancelAcceptance(request._id)}
//                   className="bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-700 transition"
//                   disabled={loading}
//                 >
//                   {loading ? <LoadSpinner /> : "Cancel Acceptance"}
//                 </button>
//               )}
//             </div>
//             {request.status === "assigned" && request.selectedJobSeeker === userId && (
//               <div className="mt-4 border-t pt-4">
//                 <h4 className="text-md font-semibold text-gray-800">Chat</h4>
//                 <div className="border border-gray-200 rounded-md p-2 h-40 overflow-y-auto bg-gray-50">
//                   {(messages[request._id] || []).map((msg, idx) => (
//                     <p
//                       key={idx}
//                       className={`text-sm ${msg.senderId === userId ? "text-right text-blue-600" : "text-left text-gray-600"}`}
//                     >
//                       <span className="font-medium">{msg.senderId === userId ? "You" : "Employer"}:</span> {msg.message}
//                     </p>
//                   ))}
//                 </div>
//                 <div className="mt-2 flex space-x-2">
//                   <input
//                     type="text"
//                     value={chatInput}
//                     onChange={(e) => setChatInput(e.target.value)}
//                     placeholder="Type a message..."
//                     className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
//                   />
//                   <button
//                     onClick={() => sendMessage(request._id)}
//                     className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition"
//                   >
//                     Send
//                   </button>
//                 </div>
//                 <div className="mt-4 flex space-x-2">
//                   <button
//                     onClick={() => startCall(request._id)}
//                     className="bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 transition"
//                   >
//                     Video Call
//                   </button>
//                   <button
//                     onClick={() => makePhoneCall(request.userIdDetails.phoneNumber)}
//                     className="bg-gray-600 text-white py-2 px-4 rounded-md hover:bg-gray-700 transition"
//                   >
//                     Phone Call
//                   </button>
//                 </div>
//                 <div className="mt-4 flex space-x-4">
//                   <video id={`localVideo-${request._id}`} autoPlay playsInline className="w-40 h-40 rounded-md border"></video>
//                   <video id={`remoteVideo-${request._id}`} autoPlay playsInline className="w-40 h-40 rounded-md border"></video>
//                 </div>
//               </div>
//             )}
//           </div>
//         ))}
//       </div>
//       {selectedRequest && (
//         <Modal show={!!selectedRequest} onClose={() => setSelectedRequest(null)}>
//           <Modal.Header>
//             <h3 className="text-lg font-semibold text-gray-800">Request Details</h3>
//           </Modal.Header>
//           <Modal.Body>
//             <div className="space-y-2">
//               <p><span className="font-medium">Position:</span> {selectedRequest.position}</p>
//               <p><span className="font-medium">Duration:</span> {selectedRequest.durationValue} {selectedRequest.durationType}</p>
//               <p><span className="font-medium">Amount:</span> N{selectedRequest.amount}</p>
//               <p><span className="font-medium">Benefits:</span> {selectedRequest.benefits?.join(", ") || "None"}</p>
//               {selectedRequest.userIdDetails && (
//                 <div>
//                   <p><span className="font-medium">Employer:</span> {selectedRequest.userIdDetails.companyName}</p>
//                   <p><span className="font-medium">Email:</span> {selectedRequest.userIdDetails.email}</p>
//                   <p><span className="font-medium">Phone:</span> {selectedRequest.userIdDetails.phoneNumber}</p>
//                 </div>
//               )}
//             </div>
//           </Modal.Body>
//           <Modal.Footer>
//             <button
//               onClick={() => setSelectedRequest(null)}
//               className="bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-700 transition"
//             >
//               Close
//             </button>
//           </Modal.Footer>
//         </Modal>
//       )}
//     </div>
//   );
// };

// export default UrgentJobSeekerAccept;